import { useRef, useEffect } from 'react'

// Hook

export const usePrevious = <T extends $TSFixMe = $TSFixMe>(
  value: T,
  shouldUpdate = true
) => {
  // The ref object is a generic container whose current property is mutable ...
  // ... and can hold any value, similar to an instance property on a class
  const ref = useRef<T>()

  // Store current value in ref
  useEffect(() => {
    if (shouldUpdate) {
      ref.current = value
    }
  }, [value, shouldUpdate]) // Only re-run if value changes

  // Return previous value (happens before update in useEffect above)
  return ref.current
}
